import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogoGenericoComponent } from 'src/app/shared/dialogo-generico/dialogo-generico.component';

@Component({
  selector: 'app-asignar-perfil',
  templateUrl: './asignar-perfil.component.html',
  styleUrls: ['./asignar-perfil.component.css']
})
export class AsignarPerfilComponent implements OnInit {

  constructor(public dialogModalGeneric: MatDialog, private router: Router) { }

  ngOnInit() {
  }

  asignarPerfilForm = new FormGroup({
    nombreUsuario: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]),
    nuevoPerfil: new FormControl('', [Validators.required]),
  });

  onSubmit(): void {
    if (this.asignarPerfilForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.dialogModalGeneric.open(DialogoGenericoComponent, {
      width: '25rem',
      disableClose: true,
      data: {
        icon: 'warning',
        message: '¿Está seguro de modificar el perfil al usuario?',
        btCancel: true,
        btAccept: true,
        btClose: false,
        actionBtCancel: 'cancelModal',
        actionBtAccept: 'cancelWithAction',
        actionBtClose: '',
        result: 'info'
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result === 'action') {
        //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.asignarPerfilForm.value, null, 4));
        this.navigateMenu('home');
      } else {
        dialog.close(false);
      }
    });
  }

  navigateMenu(tag: string) {
    this.router.navigate(['/' + tag]);
  }

}
